import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useEffect } from 'react';
import Login from '@pages/Login/Index';
import Tipo from '@pages/Cadastros_e_Parametros/Tipo/Index';
import Processo from '@pages/Cadastros_e_Parametros/Processo/Index';
import ItensProcesso from '@pages/Cadastros_e_Parametros/ItemProcesso/Index';
import Formularios from '@pages/Cadastros_e_Parametros/Formularios/Index';
import Documentos from '@pages/Cadastros_e_Parametros/Documentos/Index';
import AmostrasUnidade from '@pages/Relatorios_e_Indicadores/AmostrasUnidade/Index';
import AmostrasItem from '@pages/Relatorios_e_Indicadores/AmostrasItem/Index';
import RelatorioPermissoes from '@pages/Relatorios_e_Indicadores/RelatorioPermissoes/Index';
import RelatorioHistorico from '@pages/Relatorios_e_Indicadores/RelatorioHistorico/Index';
import RelatorioFinalAuditoria from '@pages/Relatorios_e_Indicadores/RelatorioFinalAuditoria/Index';
import Tarefas from '@pages/Planejamento/Tarefas/Index';
import CalendarioGPG from '@pages/Planejamento/CalendarioGPG/Index';
import ManualSistema from '@pages/Procedimentos_e_Manuais/ManualSistema/Index';
import ProcedimentosBasicos from '@pages/Procedimentos_e_Manuais/ProcedimentosBasicos/Index';
import UnidadeGerencia from '@pages/Cadastros_e_Parametros/UnidadeGerencia/Index';
import Servico from '@pages/Cadastros_e_Parametros/Servico/Index';
import Compliance from '@pages/Solicitacoes_Pendencias/Compliance/Index';
import CriarSolicitacao from '@pages/Solicitacoes_Pendencias/Solicitacao/Admin/Create/Index';
import NotFound from '@pages/NotFound/Index';
import ProtectedRoute from '@routes/ProtectedRoute';
import Layout from '../components/Layout/Layout';
import Home from '@pages/Home/Index';
import RelatorioFormularios from '@pages/Relatorios_e_Indicadores/RelatorioFormularios/Index';
import { perfisAdmin, perfisTodos } from '@utils/auth/perfis';
import AuthCallback from '@pages/AuthCallback/Index';
import Erro403 from '@pages/Erro403/Index';
import PageTemplateEmail from '@pages/Cadastros_e_Parametros/TemplateEmails/Index';
import PageUsuarios from '@pages/Cadastros_e_Parametros/Usuarios/Index';
import SolicitacaoRoleSwitch from '@pages/Solicitacoes_Pendencias/Solicitacao/SolicitacaoRoleSwitch';
import ConsultarSolicitacoesRoleSwitch from '@pages/Solicitacoes_Pendencias/Solicitacao/ConsultarSolicitacoesRoleSwitch';

function AnimatedRoutes() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // reseta o scroll ao trocar de rota
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>

        {/* Rota pública */}
        <Route path="/Login" element={<Login />} />

        {/* Rota pública de callback */}
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Rota pública de erro de acesso ao sistema */}
        <Route path="/erro403" element={<Erro403 />} />

        {/* Rotas privadas */}
        <Route element={<ProtectedRoute allowedRoles={perfisTodos} />}>
          <Route path="/" element={<Layout />}>

            <Route index element={<Home />} />

            {/* Rotas exclusivas dos auditores/admins */}
            <Route element={<ProtectedRoute allowedRoles={perfisAdmin} />}>
              <Route path='/Compliance' element={<Compliance />} />
              <Route path="/CriarSolicitacao" element={<CriarSolicitacao />} />

              <Route path="/RelatorioFormularios" element={<RelatorioFormularios />} />
              <Route path="/AmostrasUnidade" element={<AmostrasUnidade />} />
              <Route path="/AmostrasItem" element={<AmostrasItem />} />
              <Route path="/RelatorioPermissoes" element={<RelatorioPermissoes />} />
              <Route path="/RelatorioHistorico" element={<RelatorioHistorico />} />
              <Route path="/RelatorioFinalAuditoria" element={<RelatorioFinalAuditoria />} />

              <Route path="/Tarefas" element={<Tarefas />} />
              <Route path="/CalendarioGPG" element={<CalendarioGPG />} />

              <Route path="/UnidadeGerencia" element={<UnidadeGerencia />} />
              <Route path="/Servico" element={<Servico />} />
              <Route path="/Tipo" element={<Tipo />} />
              <Route path="/Processo" element={<Processo />} />
              <Route path="/ItensProcesso" element={<ItensProcesso />} />
              <Route path="/TemplateEmails" element={<PageTemplateEmail />} />
              <Route path="/Formularios" element={<Formularios />} />
              <Route path="/Documentos" element={<Documentos />} />
              <Route path="/Usuarios" element={<PageUsuarios />} />

              <Route path="/ManualSistema" element={<ManualSistema />} />
              <Route path="/ProcedimentosBasicos" element={<ProcedimentosBasicos />} />
            </Route>

            {/* Rotas da solicitação separadas por perfil do usuário */}
            <Route element={<ProtectedRoute allowedRoles={perfisTodos} />}>
              <Route path="/Solicitacao/:id" element={<SolicitacaoRoleSwitch />} />
              <Route path="/ConsultarSolicitacoes" element={<ConsultarSolicitacoesRoleSwitch />} />
            </Route>

          </Route>
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;